export const STATUS_BADGE_COLORS = {
  danger: 'border-red-300 bg-red-100 text-red-800 hover:bg-red-100',
  in_progress: 'border-purple-300 bg-purple-100 text-purple-800 hover:bg-purple-100',
  info: 'border-blue-300 bg-blue-100 text-blue-800 hover:bg-blue-100',
  neutral: 'border-gray-300 bg-gray-100 text-gray-800 hover:bg-gray-100',
  success: 'border-green-300 bg-green-100 text-green-800 hover:bg-green-100',
  warning: 'border-yellow-300 bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
} as const;

export const STATUS_BADGE_SOLID_COLORS = {
  danger: 'border-transparent bg-red-500 text-white hover:bg-red-600',
  in_progress: 'border-transparent bg-purple-500 text-white hover:bg-purple-600',
  info: 'border-transparent bg-blue-500 text-white hover:bg-blue-600',
  neutral: 'border-transparent bg-gray-500 text-white hover:bg-gray-600',
  success: 'border-transparent bg-green-500 text-white hover:bg-green-600',
  warning: 'border-transparent bg-yellow-500 text-white hover:bg-yellow-600',
} as const;
